// 移交对象
const HandoverObject = () => {
  return import('../../../components/business/HandoverObject')
}
// 对象信息
const ObjectInfo = () => {
  return import('../../../components/business/ObjectInfo/index')
}
// 移交文档
const HandoverDocuments = () => {
  return import('../../../components/business/HandoverDocuments')
}
// 剖切相关
const ClipTool = () => {
  return import('../../../components/basic/ClipTool')
}
// 电子围栏详情
const ElectronicFenceInfo = () => {
  return import('../../../components/business/ElectronicFenceInfo')
}
// 智能管控
const IntelligentControl = () => {
  return import('../../../components/business/IntelligentControl')
}
// 风险隐患详情
const DangerHiddenDetails = () => {
  return import('../../../components/business/DangerHiddenDetails/DangerHiddenDetail')
}
// 建筑操作
const BuildingOperation = () => {
  return import('../../../components/business/BuildingOperation')
}
// 人员信息
const PersonnelInfo = () => {
  return import('../../../components/business/PersonnelInfo')
}
// 安防一张图
const SmartSecurityPage = () => {
  return import('../../../components/business/SmartSecurityPage')
} // 安防一张图-摄像头列表
const ScameraList = () => {
  return import('../../../components/business/components/smartSecurity/scameraList')
}
// 济南热电一张图
const JiNanAPicture = () => {
  return import('../../../components/business/JiNanAPicture/JiNanAPicture')
}
// 济南热电报警中心
const JiNanEmergency = () => {
  return import('../../../components/business/JiNanEmergency/JiNanEmergency')
}
// 济南热电两票列表
const JiNanTwoTicket = () => {
  return import('../../../components/business/JiNanTwoTicket/JiNanTwoTicket')
}
// 安防一张图-门禁道匝列表
const AccessControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessControlGateList')
}
// 安防一张图-门禁列表
const AccessDoorControlGateList = () => {
  return import('../../../components/business/components/smartSecurity/accessDoorControlGateList')
}
// 设备台账
const DeviceLedger = () => {
  return import('../../../components/business/DeviceLedger/index')
}
// 设备台账 二级菜单-设备实时监测信息
const DeviceRealTimeInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceRealTimeInfo')
}
// 设备台账 二级菜单-设备基础信息
const DeviceRealBasicInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceRealBasicInfo')
}
// 设备台账 二级菜单-设备关联文档
const DeviceDocs = () => {
  return import('../../../components/business/DeviceLedger/DeviceDocs')
}
// 设备台账 二级菜单-设备缺陷记录
const DeviceDefectRecord = () => {
  return import('../../../components/business/DeviceLedger/DeviceDefectRecord')
}
// 设备台账 二级菜单-检修记录
const DeviceMaintainRecord = () => {
  return import('../../../components/business/DeviceLedger/DeviceMaintainRecord')
}
// 设备台账 二级菜单-关联监控
const DeviceMonitor = () => {
  return import('../../../components/business/DeviceLedger/DeviceMonitor')
}
// 设备台账 二级菜单-设备属性
const DeviceInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceInfo')
}

// 设备台账 二级菜单-设备属性
const DeviceOtherInfo = () => {
  return import('../../../components/business/DeviceLedger/DeviceOtherInfo')
}

// 巡检路线
// const InspectRoute = () => {
//   return import('../../../components/business/InspectRoute/index')
// }
// // 巡检二级菜单
// const InspectRight = () => {
//   return import('../../../components/business/InspectRoute/InspectRight')
// }
// 以下为广西定制功能 end
// 三维寻阀
const ValveManagement = () => {
  return import('../../../components/business/ValveManagement/PipeList')
}
// 三维寻阀-阀门列表
const ValveList = () => {
  return import('../../../components/business/ValveManagement/ValveList')
}
// 防腐保温
const AnticorrosionAndInsulation = () => {
  return import('../../../components/business/AnticorrosionAndInsulation/PipeList')
}
// 防腐保温-材料详情
const PrtMaterialDetail = () => {
  return import('../../../components/business/AnticorrosionAndInsulation/PrtMaterialDetail')
}
// 物料统计
const MaterialStatistics = () => {
  return import('../../../components/business/MaterialStatistics/PipeList')
}
// 物料统计-关联物料清单
const AssociatedMaterial = () => {
  return import('../../../components/business/MaterialStatistics/AssociatedMaterial')
}
// 管线抽离
const PipeExtraction = () => {
  return import('../../../components/business/PipeExtraction')
}
// 盲板综合展示
const BlindPlateExhibition = () => {
  return import('../../../components/business/BlindPlateExhibition/BlindPlateList')
}
// 三查四定
const ChecksAndSets = () => {
  return import('../../../components/business/ChecksAndSets/ProblemList')
}
// 断面分析
const CrossSectionAnalysis = () => {
  return import('../../../components/business/CrossSectionAnalysis/index')
}
// 流向分析
const PipeFlowAnalysis = () => {
  return import('../../../components/business/PipeFlowAnalysis/index')
}
// SIS系统
const SisSystem = () => {
  return import('../../../components/business/SisSystem/index')
}
// SIS系统 二级菜单-设备列表
const DeviceList = () => {
  return import('../../../components/business/SisSystem/DeviceList')
}
// 以上为广西定制功能 end

const exportComponents = {
  MonitorList: () => {
    return import('../../../components/business/MonitorList/MonitorList.vue')
  },
  CameraList: () => {
    return import('../../../components/business/MonitorList/CameraList')
  },
  CameraInfo: () => {
    return import('../../../components/business/MonitorList/CameraInfo')
  },
  NearbyCameras: () => {
    return import('../../../components/business/MonitorList/NearbyCameras')
  },
  ModelTree: () => {
    return import('../../../components/basic/ModelTree')
  },
  PreferenceSetting: () => {
    return import('../../../components/basic/PreferenceSetting')
  },
  GlobalSetting: () => {
    return import('../../../components/basic/GlobalSetting')
  },
  AllClip: ClipTool,
  PartClipBox: ClipTool,
  ThreePanel: ClipTool,
  HandoverObject,
  PersonnelInfo,
  AccessControlGateList,
  AccessDoorControlGateList,
  ObjectInfo,
  HandoverDocuments,
  ValveManagement,
  ValveList,
  JiNanAPicture,
  JiNanEmergency,
  JiNanTwoTicket,
  AnticorrosionAndInsulation,
  PrtMaterialDetail,
  PipeExtraction,
  MaterialStatistics,
  AssociatedMaterial,
  ChecksAndSets,
  CrossSectionAnalysis,
  BlindPlateExhibition,
  PipeFlowAnalysis,
  ElectronicFenceInfo,
  PersonPosition: IntelligentControl,
  DangerHiddenDetails,
  BuildingOperation,
  SisSystem,
  DeviceList,
  DeviceLedger,
  DeviceRealTimeInfo,
  DeviceRealBasicInfo,
  DeviceDocs,
  DeviceDefectRecord,
  DeviceMaintainRecord,
  DeviceMonitor,
  DeviceInfo,
  DeviceOtherInfo,
  SmartSecurityPage,
  ScameraList
}
export default exportComponents
